//#region src/receipt_header_image_position.ts
let ReceiptHeaderImagePosition = /* @__PURE__ */ function(ReceiptHeaderImagePosition) {
	ReceiptHeaderImagePosition["Above"] = "above";
	ReceiptHeaderImagePosition["Below"] = "below";
	return ReceiptHeaderImagePosition;
}({});
//#endregion
export { ReceiptHeaderImagePosition };

//# sourceMappingURL=receipt_header_image_position.js.map